import { Drawer } from '@mui/material';
import { WorkFormProvider, WorkFormProviderProps } from './work-form-provider';

type Props = {
  isSidebarOpen: boolean;
  closeSidebar: () => void;
} & Omit<WorkFormProviderProps, 'cancel'>;

export const WorkFormSidebar = ({ isSidebarOpen, closeSidebar, ...rest }: Props) => {
  return (
    <>
      <Drawer anchor="right" open={isSidebarOpen} onClose={closeSidebar}>
        <WorkFormProvider cancel={closeSidebar} {...rest} />
      </Drawer>
    </>
  );
};
